import { useEffect, useState } from "react";
import { Box, Button, Image, Text, useDisclosure } from "@chakra-ui/react";
import { getApi } from "common/services/api";
import { HasAccess } from "../../../../common/utils/accessUtils";
import CommonCheckTable from "common/components/checktable";
import { SearchIcon } from "@chakra-ui/icons";
import { useLocation, useNavigate } from "react-router-dom";
import CommonDeleteModel from "common/components/commonDeleteModel";
import { deleteApi } from "common/services/api";
import { toast } from "react-toastify";
import viewIcon from "common/assets/img/viewIcon.png";
import editIcon from "common/assets/img/editIcon.png";
import DateFormatter from "common/utils/dateFormater";
import { globalStyles } from "common/theme/styles";
import { recruitConstant } from "services/Recruit/constant";
import { bgVtableData } from "services/Recruit/data/bgData";
import deleteIcon from "common/assets/img/deleteIcon.png";
const BgVerification = () => {
    const title = recruitConstant.bgVerification;
    const [action, setAction] = useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selectedId, setSelectedId] = useState();
    const [selectedValues, setSelectedValues] = useState([]);
    const [advanceSearch, setAdvanceSearch] = useState(false);
    const [getTagValuesOutSide, setGetTagValuesOutside] = useState([]);
    const [searchboxOutside, setSearchboxOutside] = useState("");
    const [deleteMany, setDeleteMany] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [displaySearchData, setDisplaySearchData] = useState(false);
    const [searchedData, setSearchedData] = useState([]);
    const colors = globalStyles.colors;
    const [tableData, setTableData] = useState(bgVtableData)
    const [permission, leadAccess, contactAccess] = HasAccess([
        "Tasks",
        "Leads",
        "Contacts",
    ]);
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state;
    const actionHeader = {
        Header: recruitConstant.actions,
        isSortable: false,
        center: true,
        cell: ({ row }) => (
            <Text fontSize="md" fontWeight="900" textAlign={"center"}>
                <Box className="actionCellContainer">
                    {/* {permission?.update && (
                        <Image
                            onClick={() =>
                                navigate(`/recruit/bgVerificationCreate/${row?.values?.id}`)
                            }
                            src={viewIcon}
                            h={"20px"}
                            w={"20px"}
                        />
                    )} */}
                    {permission?.view && (
                        <Image
                            onClick={() =>
                                navigate(`/recruit/bgVerificationCreate/${row?.values?.id}`)
                            }
                            src={editIcon}
                            h={"20px"}
                            w={"20px"}
                        />
                    )}
                    {permission?.delete && (
                        <Box className="toolTipBox">
                            <Image
                                onClick={() => {
                                    setDeleteMany(true);
                                    setSelectedValues([row?.values?.id]);
                                }}
                                src={deleteIcon}
                                h={"20px"}
                                w={"20px"}
                            />
                            <Text className="toolTip">{recruitConstant.delete}</Text>
                        </Box>
                    )}

                </Box>
            </Text>
        ),
    };

    const tableColumns = [
        {
            Header: "#",
            accessor: "id",
            isSortable: false,
            width: 5,
        },

        {
            Header: recruitConstant.empId,
            accessor: "empId"
        },
        {
            Header: recruitConstant.empName,
            accessor: "empName",
        },

        {
            Header: recruitConstant.doj,
            accessor: "doj",
        },
        {
            Header: recruitConstant.createAt,
            accessor: "createAt",
        },
        {
            Header: recruitConstant.sharedAt,
            accessor: "sharedAt",
        },
        {
            Header: recruitConstant.sharedTo,
            accessor: "sharedTo",
        },
        {
            Header: recruitConstant.link,
            accessor: "link",
        },
        ...(permission?.update || permission?.view || permission?.delete
            ? [actionHeader]
            : []),
    ];

    const handleDeleteProfile = async (ids) => {

        const updatedTableData = tableData.filter((item) => !ids.includes(item.id));
        setTableData(updatedTableData);
        setSelectedValues([]);
        setDeleteMany(false);
        toast.success(recruitConstant.deleteMsg);
    };

    const [columns, setColumns] = useState([...tableColumns]);
    const [selectedColumns, setSelectedColumns] = useState([...tableColumns]);

    const dataColumn = tableColumns.filter((item) =>
        selectedColumns.some((column) => column.Header === item.Header)
    );
    return (
        <div>
            <CommonCheckTable
                title={title}
                isLoading={isLoading}
                columnData={columns}
                dataColumn={dataColumn}
                allData={tableData}
                tableData={tableData}
                searchDisplay={displaySearchData}
                setSearchDisplay={setDisplaySearchData}
                searchedDataOut={searchedData}
                setSearchedDataOut={setSearchedData}
                tableCustomFields={[]}
                access={permission}
                action={action}
                setAction={setAction}
                selectedColumns={selectedColumns}
                setSelectedColumns={setSelectedColumns}
                isOpen={isOpen}
                onClose={onclose}
                state={state}
                onOpen={onOpen}
                selectedValues={selectedValues}
                setSelectedValues={setSelectedValues}
                setDelete={setDeleteMany}
                AdvanceSearch={
                    <Button
                        variant="outline"
                        className="advance-search-button"
                        colorScheme="brand"
                        leftIcon={<SearchIcon />}
                        mt={{ sm: "5px", md: "0" }}
                        size="sm"
                        onClick={() => setAdvanceSearch(true)}
                    >
                        {recruitConstant.advanceSearch}
                    </Button>
                }
                getTagValuesOutSide={getTagValuesOutSide}
                searchboxOutside={searchboxOutside}
                setGetTagValuesOutside={setGetTagValuesOutside}
                setSearchboxOutside={setSearchboxOutside}
            />
            <CommonDeleteModel
                isOpen={deleteMany}
                onClose={() => setDeleteMany(false)}
                type={recruitConstant.bgVerification}
                handleDeleteData={handleDeleteProfile}
                ids={selectedValues}
            />
        </div>
    );
};

export default BgVerification;
